export default __webpack_public_path__ + "static/media/Loretta_Joseph_AHV_In_Moms_We_Trust.746b2987.jpg";